import React, { useState, useMemo } from 'react';
import { useInterval } from '../../../hooks/useInterval.es.js';
import styled from '@emotion/styled';
import { calculateTimeDelta } from '../Countdown/Countdown.es.js';

const addPaddingNumber = (number) => number.toString().padStart(2, "0");
const daysString = (days) => days === 0 ? `` : `${days} ng\xE0y`;
const BoldWrapper = styled.span`
  font-weight: bold;
`;
const CountdownText = ({
  date,
  className
}) => {
  const [duration, setDuration] = useState(calculateTimeDelta(date));
  useInterval(() => {
    setDuration(calculateTimeDelta(date));
  }, 1e3, duration.durationInMs === 0);
  const message = useMemo(() => {
    if (daysString(duration.days) !== ``) {
      return /* @__PURE__ */ React.createElement("span", null, "C\xF2n ", /* @__PURE__ */ React.createElement(BoldWrapper, null, daysString(duration.days)));
    } else {
      return /* @__PURE__ */ React.createElement("span", null, "C\xF2n ", /* @__PURE__ */ React.createElement(BoldWrapper, null, addPaddingNumber(duration.hours), ":", addPaddingNumber(duration.minutes), ":", addPaddingNumber(duration.seconds)));
    }
  }, [duration]);
  return /* @__PURE__ */ React.createElement("span", {
    className
  }, message);
};

export { CountdownText };
